import React from "react";
import { NavLink as RouterLink } from "react-router-dom";
import {
  Button,
  Box,
  CardMedia,
  Link,
  Typography,
  Container,
} from "@material-ui/core";
import useStyles from "./Style.js";
import Logo from "../../assets/Logo.png";
import InstagramIcon from "@material-ui/icons/Instagram";
import FacebookIcon from "@material-ui/icons/Facebook";

const Footer = () => {
  const classes = useStyles();
  const click = () => {
    window.scrollTo(0, 0);
  };

  return (
    <Container className={classes.footerContainer}>
      <Box component="div" className={classes.footer}>
        <Box className={classes.footerBoxOne} component="div">
          <CardMedia component="img" image={Logo} className={classes.logo} />
          <Typography className={classes.description} p="true">
            Amet minim mollit non deserunt ullamco est sit aliqua dolor do amet
            sint. Velit officia consequat duis enim velit mollit. Exercitation
            veniam consequat sunt nostrud amet.
          </Typography>
        </Box>
        <Box component="div" className={classes.footerBoxTwo}>
          <Link
            component={RouterLink}
            style={{ textDecoration: "none" }}
            activeClassName={classes.activeLink}
            exact
            to="/"
            disableRipple
          >
            <Button
              className={classes.link}
              variant="text"
              activeClassName={classes.active}
              component={RouterLink}
              exact
              to="/"
              disableRipple
              onClick={click}
            >
              Inicio
            </Button>
          </Link>
          <Link
            component={RouterLink}
            style={{ textDecoration: "none" }}
            activeClassName={classes.activeLink}
            exact
            to="/aboutus"
          >
            <Button
              className={classes.link}
              variant="text"
              activeClassName={classes.active}
              exact
              to="/aboutus"
              component={RouterLink}
              disableRipple
              onClick={click}
            >
              Nosotros
            </Button>
          </Link>
          <Link
            style={{ textDecoration: "none" }}
            component={RouterLink}
            activeClassName={classes.activeLink}
            to="/products"
          >
            <Button
              className={classes.link}
              variant="text"
              activeClassName={classes.active}
              component={RouterLink}
              to="/products"
              disableRipple
              onClick={click}
            >
              Productos
            </Button>
          </Link>
          <Link
            style={{ textDecoration: "none" }}
            component={RouterLink}
            activeClassName={classes.activeLink}
            to="/content"
          >
            <Button
              className={classes.link}
              variant="text"
              activeClassName={classes.active}
              component={RouterLink}
              to="/content"
              disableRipple
              onClick={click}
            >
              Contenido
            </Button>
          </Link>
          <Link
            style={{ textDecoration: "none" }}
            component={RouterLink}
            activeClassName={classes.activeLink}
            to="/contact"
          >
            <Button
              className={classes.link}
              variant="text"
              activeClassName={classes.active}
              component={RouterLink}
              to="/contact"
              disableRipple
              onClick={click}
            >
              Contacto
            </Button>
          </Link>
        </Box>
        <Box className={classes.footerBoxThree} component="div">
          <Box component="div" className={classes.icons}>
            <InstagramIcon className={classes.instagram} />
            <FacebookIcon className={classes.facebook} />
          </Box>
          <Typography className={classes.terms} variant="body2">
            Terminos y Condiciones de uso | Politicas de privacidad
          </Typography>
        </Box>
        <Box component="div" className={classes.footerBoxFour}>
          <Typography className={classes.website} variant="body1">
            www.velasnazareno.com
          </Typography>
        </Box>
      </Box>
    </Container>
  );
};

export default Footer;
